import BoardSceneRenderer from './BoardSceneRenderer';

type ClassroomBoardViewProps = {
  boardDisplayState: any;
};

export default function ClassroomBoardView({ boardDisplayState }: ClassroomBoardViewProps) {
  if (!boardDisplayState) {
    return (
      <div className="absolute inset-0 flex items-center justify-center bg-gray-950 text-white">
        <div className="rounded-2xl border border-white/20 bg-white/5 px-8 py-6 text-2xl font-semibold">
          Live-Unterricht wartet auf Freigabe
        </div>
      </div>
    );
  }

  return (
    <div className="absolute inset-0 z-[180] flex items-center justify-center bg-gradient-to-b from-gray-100 to-gray-300 p-8">
      <BoardSceneRenderer state={boardDisplayState} />
    </div>
  );
}
